import { UNSUBSCRIBE_GENERIC, UNSUBSCRIBE_GENERIC_ERROR, UNSUBSCRIBE_GENERIC_SUCCESS } from './Unsubscribe.actions'

const unsubscribeState = {
  error: 0,
  loading: false,
  unsubscribe: false
}

/**
 * The Unsubscribe section' reducer.
 */
const unsubscribeReducer = (state = unsubscribeState, { type }) => {
  switch (type) {
    case UNSUBSCRIBE_GENERIC: {
      return { ...state, loading: true }
    }
    case UNSUBSCRIBE_GENERIC_ERROR: {
      return { ...state, error: state.error + 1, loading: false }
    }
    case UNSUBSCRIBE_GENERIC_SUCCESS: {
      return { ...state, unsubscribe: true, loading: false }
    }
    default: {
      return state
    }
  }
}

export default unsubscribeReducer
